import { Component, OnInit } from '@angular/core';
import { InsApproveQuotationService } from './ins-approve-quotation.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'app-ins-approve-quotation',
  templateUrl: './ins-approve-quotation.component.html',
  styleUrls: ['./ins-approve-quotation.component.scss']
})
export class InsApproveQuotationComponent implements OnInit {
  quotationId: any;
  spareGarageId: string;
  surveyor: any;
  surveyorContact: any;
  claimNo: any;
  spareRequest: any;
  approvedItemsCount: number;
  status: number;
  recievedItemsLength: any[];
  approvedItemsLength: any;
isOpen: any;
  spareRequestItemList: any;
  

  constructor(
    private insuranceService: InsApproveQuotationService,
    private _fuseConfigService: FuseConfigService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) { }
   items: any[] = [];
  isLoading = false;
  errorMessage: string | null = null;
  selectAll = false;
  selectedCount = 0;
  totalAmount = 0;
  showDetails = false;
  activeTab: 'received' | 'approved' = 'received';
  spareQuotation: any = null;
  receivedItemsCount = 0;
  // approvedItemsCount = 0;
  claimType: string = '';
  selectAllReceived = false;
  selectAllApproved = false;
  totalReceivedAmount = 0;
  totalApprovedAmount = 0;
  // Received tab
  selectedReceivedCount = 0;
  selectedApprovedCount = 0;
  
  // Popup control
  showApprovePopup = false;
  claimId = '';
  showPaymentSheet = false;
  paymentOptions = [
    { key: 'insurance', label: 'Insurance Coverage' },
    { key: 'customer', label: 'Customer Payment' },
    { key: 'other', label: 'Other' } // hidden in UI
  ];
  selectedPayment: 'insurance' | 'customer' | null = null;

  // Quote Summary Data
  quoteSummary = {
    status: '',
    approvalDate: '',
    approvedBy: '',
    nextStep: '',
    totalMRP: 0,
    totalSellingPrice: 0,
    totalSavings: 0
  };

  ngOnInit(): void {
    this._fuseConfigService.config = {
      layout: {
        navbar: { hidden: true },
        toolbar: { hidden: true },
        footer: { hidden: true },
        sidepanel: { hidden: true }
      }
    };
  this.quotationId = this.route.snapshot.paramMap.get('quotationid') || '';
  this.spareGarageId = this.route.snapshot.paramMap.get('sparegarageid') || '';

  // console.log('Received Quotation ID:', this.quotationId);
  // console.log('Received Spare Garage ID:', this.spareGarageId);

  this.fetchQuotationNew();
  }

  // fetchQuotation() {
  //   this.isLoading = true;
  //   this.errorMessage = null;

  //   this.insuranceService.getSpareQuotation(this.quotationId, this.spareGarageId).subscribe({
  //     next: (res) => {
  //       const spareQuotation = res?.response?.body?.spareQuotation;
  //       const spareRequest = res?.response?.body?.spareRequest; // ✅ get claim info
  //       this.spareQuotation = spareQuotation;
  //       this.spareRequest = spareRequest;
  //       // console.log("this.spareQuotation ----,",this.spareQuotation);
  //       // console.log("spareRequest ----,",this.spareRequest);

  //       // Assign claim and surveyor details
  //       // ✅ Fix: assign null if missing
  //       this.claimType = spareRequest?.claimType || null;
  //       this.claimNo = spareRequest?.claimNo || null;
  //       this.surveyor = spareRequest?.surveyor || null;
  //       this.surveyorContact = spareRequest?.surveyorContact || null;

  //       this.claimId = spareQuotation?.id ? `QUO-${spareQuotation.id}` : '';

  //       const apiItems = spareQuotation?.itemList || [];
  //       // console.log("apiItem---",apiItems);

  //       // Map items from API
  //       this.items = apiItems.map(apiItem => ({
  //         name: apiItem.itemName || 'N/A',
  //         brand: apiItem.brandName || 'N/A',
  //         code: apiItem.partNumber || 'N/A',
  //         // discount: apiItem.sellingDiscount || 0,
  //         sellingDiscount: apiItem.sellingDiscount || 0,
  //         date: apiItem.edt ? `EDT ${apiItem.edt}` : 'N/A',
  //         price: apiItem.sellingPrice || 0,
  //         mrp: apiItem.mrp || 0,
  //         qty: apiItem.itemQuantity || 1,
  //         selected: false,
  //         status: apiItem.status,
  //         // Correct: keep the item's actual status
  //         // status: apiItem.status,
  //         id: apiItem.id,
  //         lineitemId: apiItem.lineitemId,
  //         spareQuotationId: spareQuotation?.id,
  //         spareGarageId: res?.spareGarageId,
  //         paymentSource: apiItem.paymentSource || null // ✅ take from API response
  //       }));
  //       // console.log("this.items----",this.items);

  //       // Restore assigned payment sources from localStorage
  //       // this.items.forEach(item => {
  //       //   const savedPayment =  item.paymentSource;
  //       //   if (savedPayment) item.paymentSource = savedPayment;
  //       // });

  //       // Update counts and summary
  //       this.updateItemCounts();
  //       this.updateQuoteSummary();
  //       this.isLoading = false;
  //     },
  //     error: (err) => {
  //       console.error('API Error:', err);
  //       this.errorMessage = 'Failed to load spare quotation';
  //       this.isLoading = false;
  //     }
  //   });
  // }

  fetchQuotationNew() {
  this.isLoading = true;
  this.errorMessage = null;
console.log('📡 Calling getSpareQuotationV2:', this.quotationId, this.spareGarageId);

  this.insuranceService.getSpareQuotationV2(this.quotationId,this.spareGarageId).subscribe({
    next: (res) => {
      if (res.code === 200){
        console.log('🟢 getSpareQuotationV2 called with:', this.quotationId, this.spareGarageId);

      const spareQuotation = res?.data?.spareQuotation;
      const spareRequest = res?.data?.spareRequest;
      this.spareQuotation = spareQuotation;
      this.spareRequest = spareRequest;

      // console.log("this.spareQuotation ----,", this.spareQuotation);
      // console.log("spareRequest ----,", this.spareRequest);

      // Claim and surveyor info
      this.claimType = spareRequest?.claimType || null;
      this.claimNo = spareRequest?.claimNo || null;
      this.surveyor = spareRequest?.surveyor || null;
      this.surveyorContact = spareRequest?.surveyorContact || null;

      this.claimId = spareQuotation?.id ? `QUO-${spareQuotation.id}` : '';

      const apiItems = spareQuotation?.itemList || [];
      // console.log("apiItem---", apiItems);

      // Map items
      this.items = apiItems.map(apiItem => ({
        name: apiItem.itemName || 'N/A',
        brand: apiItem.brandName || 'N/A',
        code: apiItem.partNumber || 'N/A',
        sellingDiscount: apiItem.sellingDiscount || 0,
        date: apiItem.edt ? `EDT ${apiItem.edt}` : 'N/A',
        price: apiItem.sellingPrice || 0,
        mrp: apiItem.mrp || 0,
        qty: apiItem.itemQuantity || 1,
        selected: false,
        status: apiItem.status,
        id: apiItem.id,
        lineitemId: apiItem.lineitemId,
        spareQuotationId: spareQuotation?.id,
        paymentSource: apiItem.paymentSource || null
      }));

      // console.log("this.items----", this.items);

      // Update UI summary
      this.updateItemCounts();
      this.updateQuoteSummary();
      this.isLoading = false;
      }
      else if(res.code !== 200)
    {
      this.logout();
    }
    },
    error: (err) => {
      console.error('API Error:', err);
      this.errorMessage = 'Failed to load spare quotation';
      this.isLoading = false;
    }
  });
}


  get filteredItems() {
    return this.activeTab === 'approved'
      ? this.items.filter(i => i.status === 2)
      : this.items.filter(i => i.status != 2);
  }
  
  // approveItem(item: any) {
  //   this.showApprovePopup = true;

  //   this.insuranceService.approveSpareQuotation(
  //     item.spareQuotationId,
  //     item.spareGarageId,
  //     item.id,
  //     item.lineitemId,
  //     4
  //   ).subscribe({
  //     next: () => {
  //       // Only update the item that was approved
  //       item.status = 4;

  //       this.updateItemCounts();
  //       this.updateQuoteSummary();
  //       this.fetchQuotationNew();
  //       console.log('Item approved successfully');
  //     },
  //     error: (err) => {
  //       console.error('Approval failed', err);
  //       alert('Failed to approve this item. Please try again.');
  //     }
  //   });
  // }

  logout()
  {
    localStorage.removeItem("authenticationKey");
    localStorage.removeItem("mobileNumber");
            this.router.navigate([
          '/insurance-login-otp',
          this.quotationId,
          this.spareGarageId
        ]);
  }

  approveItemNew(item: any) {
    console.log("item",this.spareGarageId)
  // ✅ Call the new API (using approveSpareQuotationNew)
  this.insuranceService.approveSpareQuotationNew(
    item.spareQuotationId,  
    this.spareGarageId,
    item.id,                
    item.lineitemId,        
    4                      
  ).subscribe({
    next: () => {
      // ✅ Update the approved item in UI
      item.status = 4;

      this.updateItemCounts();
      this.updateQuoteSummary();
      this.fetchQuotationNew();
      console.log('Item approved successfully using new API');
      this.showApprovePopup = true;
    },
    error: (err) => {
      // console.error('Approval failed using new API', err);
      alert('Failed to approve this item. Please try again.');
    }
  });
}


  updateQuoteSummary() {
    const approvedItems = this.items.filter(i => i.status == 2);

    this.quoteSummary.totalMRP = approvedItems.reduce((sum, i) => sum + i.mrp * i.qty, 0);
    this.quoteSummary.totalSellingPrice = approvedItems.reduce((sum, i) => sum + i.price * i.qty, 0);
    this.quoteSummary.totalSavings = this.quoteSummary.totalMRP - this.quoteSummary.totalSellingPrice;

    this.approvedItemsCount = approvedItems.length;
    // console.log("this.approvedItemsCount ---,",this.approvedItemsCount );

  }

  updateItemCounts() {
    // console.log("updateitemscount---",this.items);
    this.receivedItemsCount = this.items.filter(i => i.status != 2).length;
    console.log("this.items.filter(i => i.status === 1)",this.items.filter(i => i.status === 1).length);
    this.approvedItemsCount = this.items.filter(i => i.status === 2).length;
  }

toggleSelectAllReceived() {

  // console.log("item.selected---",this.selectAllReceived);
  // console.log("this.receivedItems--",this.receivedItems);
  this.receivedItems.forEach(item => {item.selected = this.selectAllReceived && item.status == 1});
    // console.log("this.receivedItems----",this.receivedItems);
  this.updateReceivedSelection();


  // Update global footer values
  // New
  this.selectedReceivedCount = this.receivedItems.filter(i => i.selected).length;
  this.totalReceivedAmount = this.receivedItems.filter(i => i.selected)
                                             .reduce((sum, i) => sum + i.mrp * i.qty, 0);

}

  toggleSelectAllApproved() {
    // console.log("this.selectAllApproved----",this.selectAllApproved);
    // console.log("this.approvedItems---",this.approvedItems);
    this.approvedItems.forEach(item => (item.selected = this.selectAllApproved) && item.status == 2);
    // console.log("this.approvedItems---",this.approvedItems);
      this.updateApprovedSelection();

      // Update global footer values
      // New
    this.selectedApprovedCount = this.approvedItems.filter(i => i.selected).length;
    this.totalApprovedAmount = this.approvedItems.filter(i => i.selected)
                                                .reduce((sum, i) => sum + i.mrp * i.qty, 0);

    }
  updateSelection() {
    if (this.activeTab === 'received') {
      const selected = this.receivedItems.filter(i => i.selected);
      this.selectedReceivedCount = selected.length;
      this.totalReceivedAmount = selected.reduce((sum, i) => sum + i.mrp * i.qty, 0);
      this.selectAllReceived = selected.length === this.receivedItems.length;
    } else {
      const selected = this.approvedItems.filter(i => i.selected);
      this.selectedApprovedCount = selected.length;
      this.totalApprovedAmount = selected.reduce((sum, i) => sum + i.mrp * i.qty, 0);
      this.selectAllApproved = selected.length === this.approvedItems.length;
    }
  }

  updateReceivedSelection() {
      // console.log("this.receivedItems----",this.receivedItems);
      this.recievedItemsLength = this.receivedItems.filter(i => i.selected && (i.status === 1))
    const selected = this.receivedItems.filter(i => i.selected && (i.status === 1));
    // console.log("selected ----",selected);
    this.totalReceivedAmount = selected.reduce((sum, i) => sum + i.mrp * i.qty, 0);
    this.selectAllReceived = selected.length === this.recievedItemsLength.length;
    // console.log("this.selecgtAll----",this.selectAllReceived);
  }

  updateApprovedSelection() {
    this.approvedItemsLength = this.approvedItems.filter(i => i.selected && (i.status === 2));
    // console.log("this.approvedItems-----",this.approvedItems);
    const selected = this.approvedItems.filter(i => i.selected && (i.status === 2));
    this.totalApprovedAmount = selected.reduce((sum, i) => sum + i.mrp * i.qty, 0);
    this.selectAllApproved = selected.length === this.approvedItemsLength.length;
    // console.log("this.selectAllApproved-----,",this.selectAllApproved);
  }

  get receivedItems() {
    return this.items.filter(i => i.status != 2);
  }

  get approvedItems() {
    return this.items.filter(i => i.status == 2);
  }

  toggleDetails() {
    this.showDetails = !this.showDetails;
  }

  setActiveTab(tab: 'received' | 'approved') {
    this.activeTab = tab;
  }


  approveQuote() {
    const selectedItems = this.items.filter(i => i.selected);
    if (selectedItems.length === 0) return;

    selectedItems.forEach(item => {
      this.approveItemNew(item);
      item.selected = false; 
    });
    this.ngOnInit();
  }


  goToQuoteApproved() {
    this.showApprovePopup = false;
    this.setActiveTab('approved');
    
  }

  closePaymentSheet() {
    this.showPaymentSheet = false;
    this.selectedPayment = null;
  }

  assignPaymentSource() {
    // console.log("this.hasSelectedItems----,",this.items);
    const hasSelectedItems = this.items.some(item => item.selected);
    if (!hasSelectedItems) {
      alert('Please select at least one item');
      return;
    }
    this.showPaymentSheet = true;
  }

  get canAssignPayment(): boolean {
    // Returns true if at least one selected item does NOT have a payment source
    // return this.items.some(item => item.selected && !item.paymentSource);
    return this.approvedItems.some(item => item.selected && !item.paymentSource);
  }

  selectPayment(payment: 'insurance' | 'customer') {
    this.selectedPayment = payment;
  }
  // assignPayment() {
  //   const selectedItems = this.approvedItems.filter(item => item.selected);

  //   if (selectedItems.length === 0) {
  //     alert('Please select at least one item');
  //     return;
  //   }

  //   if (!this.selectedPayment) {
  //     alert('Please select a payment source');
  //     return;
  //   }

  //   // Map payment for display and API
  //   const displayPayment = this.selectedPayment === 'insurance'
  //     ? 'Insurance Coverage'
  //     : 'Customer Payment';

  //   const paymentSourceParam = this.selectedPayment === 'insurance'
  //     ? 'insuranceCoverage'
  //     : 'customerPayment';

  //   const itemIds = selectedItems.map(i => i.id).join(',');
  //   const lineItemIds = selectedItems.map(i => i.lineitemId).join(',');

  //   console.log('Assign Payment:', { itemIds, lineItemIds, paymentSourceParam });

  //   this.insuranceService.approveSpareQuotationWithPayment(
  //     this.quotationId,
  //     this.spareGarageId,
  //     itemIds,
  //     lineItemIds,
  //     4,
  //     paymentSourceParam
  //   ).subscribe({
  //     next: () => {
  //       // Update only selected items locally
  //       selectedItems.forEach(item => {
  //         item.paymentSource = displayPayment;
  //         item.selected = false; // Deselect after assignment
  //         // localStorage.setItem(`paymentSource_${item.id}`, item.paymentSource);
  //       });

  //       // Update footer counts and totals
  //       this.selectedApprovedCount = 0;
  //       this.totalApprovedAmount = this.approvedItems
  //         .filter(i => i.paymentSource)
  //         .reduce((sum, i) => sum + (i.price * i.qty), 0);

  //       // Close the payment sheet
  //       this.closePaymentSheet();
  //       this.cdr.detectChanges(); 
  //       this.ngOnInit();
  //       // window.location.reload();
  //       console.log('Payment source assigned successfully');
  //     },
  //     error: (err) => {
  //       console.error('Failed to assign payment source', err);
  //       alert('Failed to assign payment. Please try again.');
  //     }
  //   });
  // }

  assignPaymentNew() {
  const selectedItems = this.approvedItems.filter(item => item.selected);

  if (selectedItems.length === 0) {
    alert('Please select at least one item');
    return;
  }

  if (!this.selectedPayment) {
    alert('Please select a payment source');
    return;
  }

  // Map payment for display and API
  const displayPayment = this.selectedPayment === 'insurance'
    ? 'Insurance Coverage'
    : 'Customer Payment';

  const paymentSourceParam = this.selectedPayment === 'insurance'
    ? 'insuranceCoverage'
    : 'customerPayment';

  const itemIds = selectedItems.map(i => i.id).join(',');
  const lineItemIds = selectedItems.map(i => i.lineitemId).join(',');

  // console.log('Assign Payment (New API):', { itemIds, lineItemIds, paymentSourceParam });

  // ✅ Use the new API function
  this.insuranceService.approveSpareQuotationWithPaymentNew(this.quotationId,this.spareGarageId,itemIds,lineItemIds,4,paymentSourceParam).subscribe({
    next: (res) => {
      if (res.code === 200)
      {
      // Update only selected items locally
      selectedItems.forEach(item => {
        item.paymentSource = displayPayment;
        item.selected = false;
      });

      // Update totals and UI
      this.selectedApprovedCount = 0;
      this.totalApprovedAmount = this.approvedItems
        .filter(i => i.paymentSource)
        .reduce((sum, i) => sum + (i.price * i.qty), 0);

      this.closePaymentSheet();
      this.cdr.detectChanges();
      this.ngOnInit();

      // console.log('✅ Payment source assigned successfully (New API)');
      }
      else if(res.code ===112)
      {
        this.logout();
      }
    },
    error: (err) => {
      console.error('❌ Failed to assign payment source (New API)', err);
      alert('Failed to assign payment. Please try again.');
    }
  });
}


  openSheet() {
    this.showDetails = true;
    // optional: focus to capture escape key
    setTimeout(() => {
      const el = document.querySelector('.accordion-section.bottom-sheet') as HTMLElement | null;
      el?.focus();
    }, 0);
  }

  closeSheet() {
    this.showDetails = false;
  }
  get totalReceivedAmountAll(): number {
    return this.receivedItems
              .reduce((sum, item) => sum + (item.mrp * item.qty), 0);
  }

  get totalApprovedAmountAll(): number {
    return this.approvedItems
              .reduce((sum, item) => sum + (item.mrp * item.qty), 0);
  }
spareQuotationHasNoPO(): boolean {
  if (!this.spareQuotation || !this.spareQuotation.itemList) return false;
  return this.spareQuotation.itemList.some(item => item.poId === 0);
}




}
